<template>
  <div class="fresco-panel">
    <div class="text-container component-container">
      <div class="start-title text header">{{ title }}</div>
    </div>
    <div v-if="subtitle" class="text-container component-container">
      <div v-if="subtitle" class="start-subtitle text">{{ subtitle }}</div>
    </div>
    <div class="button-container component-container">
      <button
        :style="{
          background: actionColour,
          color: textColour,
          'outline-color': textColour,
        }"
        class="conversation-button"
      >
        <span>Chat with us</span>
        <svg :fill="textColour" class="chat-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 27.389">
          <path
            d="M22.242 5H4.922C2.313 5 0 7.106 0 9.712v8.659C0 20.979 2.313 23 4.922 23h7.505l-1.137 3.619c-.099.619.527.924 1.073.691L21.605 23h.637C24.849 23 27 20.979 27 18.371V9.712C27 7.106 24.849 5 22.242 5z"
          />
          <path
            d="M27.242 0H9.922C7.92 0 6.103 1.245 5.36 3h16.882C25.969 3 29 6.011 29 9.712v7.957c1.748-.672 3-2.312 3-4.298V4.712C32 2.106 29.849 0 27.242 0z"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { default as ColourPicker } from '@/shared/services/color';

const props = defineProps({
  brandColour: {
    type: String,
    required: true,
  },
  actionColour: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
  },
});

const title = 'Need help?';
const textColour = computed(() => ColourPicker.getContrastingColour(props.actionColour));
</script>

<style lang="scss" scoped>
.sender-name {
  margin-top: 0.5em;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 0.25em;
}

.msg {
  font-size: 13px;
  padding: 0.75em 1.1em;
  word-break: break-all;
  word-break: break-word;
  white-space: normal;
  background: #f5f5f5;
  display: inline-block;
  border-radius: 4px;
}

.conversation-button {
  color: rgb(255, 255, 255);
  outline-color: rgb(255, 255, 255);
  width: 100%;
  border-radius: 4px;
  margin-top: 1em;
  height: 3.5em;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Open Sans', Helvetica, sans-serif;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  padding: 0;

  &:hover {
    transition: 200ms;
    filter: brightness(95%);
  }

  .chat-icon {
    width: 1.5em;
    height: 1.5em;
    margin-left: 0.75em;
  }
}
</style>
